import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Plan from "./Plan";
import plansHealth from "../../data/home_borin/plansHealth.json";
import ImgSlider from "./ImgSlider";
import socialAreasHealth from "../../data/home_borin/socialAreasHealth.json";
import clinics from "../../data/home_borin/clinics.json";

function Health() {
  const [imageSrc, setImageSrc] = useState(
    "/home_borin/assets/images/health/hall.webp"
  );

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth < 1024) {
        setImageSrc("/home_borin/assets/images/health/hall-mobile.webp");
      } else {
        setImageSrc("/home_borin/assets/images/health/hall.webp");
      }
    };

    // Chama a função na montagem do componente
    updateImage();

    // Adiciona o event listener para atualizar a imagem ao redimensionar
    window.addEventListener("resize", updateImage);

    // Remove o event listener ao desmontar o componente
    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <>
      <section id="id_health" className="header-health">
        <div className="container">
          <div className="content bg-white">
            <div className="col-lg-12">
              <div className="image-wrapper wow zoomIn slow">
                <LazyLoadImage
                  src={imageSrc}
                  alt="hall do health"
                  effect="blur"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
            </div>
            <div className="col-lg-11 d-flex justify-self-end bg-white flex-wrap">
              <div className="col-lg-6 legacy p-100">
                <div className="d-flex">
                  <div className="logo text-center d-inline-block me-20 img wow zoomIn slow align-content-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/logo.svg"
                      alt="logo da Wiser"
                      effect="blur"
                      width={"68px"}
                      height={"93px"}
                    />
                  </div>
                  <h2 className="js-splittext-lines color-gray">
                    <small className="fsz-20 ltspc-5 fw-400">LEGACY</small>{" "}
                    <br />
                    <span className="fsz-60 color-brown1 text-uppercase font-palast-regular ltspc-10 title-health">
                      HEALTH
                    </span>
                  </h2>
                </div>
                <p
                  className="fsz-16 color-gray mt-15 wow zoomIn slow ltspc-2 lh-1"
                  data-wow-delay="0.2s"
                >
                  Onde a excelência encontra a inovação. O Legacy Health foi
                  concebido para profissionais que buscam muito mais do que um
                  espaço de trabalho, buscam um ambiente que inspire confiança,
                  conforto e eficiência. Com infraestrutura de ponta e design
                  sofisticado, cada detalhe foi pensado para oferecer
                  funcionalidade e bem-estar, elevando o padrão de atendimento
                  em cada experiência.
                </p>

                <div className="mt-50">
                  <h4 className="js-splittext-lines fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Condomínio
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Inteligente
                    </strong>
                  </h4>
                  <p className="js-splittext-lines mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Com aquecimento solar, energia fotovoltaica e telemetria
                    completa, unindo sustentabilidade e eficiência.
                  </p>
                </div>

                <div className="mt-50">
                  <h4 className="js-splittext-lines fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Automação
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Completa
                    </strong>
                  </h4>
                  <p className="js-splittext-lines mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Controle total na palma da mão, oferecendo praticidade e
                    segurança.
                  </p>
                </div>

                <div className="mt-50">
                  <h4 className="js-splittext-lines fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Sistema de Gestão
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Avançado
                    </strong>
                  </h4>
                  <p className="js-splittext-lines mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Eficiência administrativa para que você foque no que
                    realmente importa.
                  </p>
                </div>

                <div className="mt-50">
                  <h4 className="js-splittext-lines fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Lazer
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Exclusivo
                    </strong>
                  </h4>
                  <p className="js-splittext-lines mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Com lago artificial, academia, lounges, espaços para
                    reuniões, festas e um coworking sofisticado.
                  </p>
                </div>
              </div>

              <div className="col-lg-5 p-80 align-content-center">
                <h3 className="lh-1">
                  <span className="js-splittext-lines fsz-35 color-gray font-palast-regular">
                    Cada pausa merece um momento
                    <strong className="js-splittext-lines fsz-40 color-brown2 font-palast-bold-italic">
                      {" "}
                      inesquecível.
                    </strong>
                  </span>
                </h3>

                <p className="js-splittext-lines fsz-16 mt-30 mb-20 color-gray lh-2 ltspc-2">
                  A área de lazer do Wiser Health foi projetada para
                  proporcionar bem-estar em cada detalhe. Com espaços elegantes
                  e funcionais, é o lugar ideal para relaxar, socializar e
                  cuidar de si.
                </p>

                <p className="js-splittext-lines fsz-16 mb-20 color-gray lh-2 ltspc-2">
                  Ambientes como o Lago de contemplação, o Coliving para
                  momentos de descontração, e a Academia equipada para um estilo
                  de vida saudável, criam um equilíbrio perfeito para seu
                  cotidiano.
                </p>

                <button
                  onClick={() => window.openModal()}
                  className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-20 wow zoomIn slow"
                >
                  <span className="ltspc-1"> Quero saber mais </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tc-slider-style" style={{ position: "relative" }}>
        <ImgSlider slides={socialAreasHealth} />
      </section>

      <div className="header-health col-lg-12 d-flex flex-wrap">
        <div className="col-lg-6 p-100">
          <h2 className="js-splittext-lines text-white">
            <span className="fsz-60 text-uppercase font-palast-regular ltspc-10">
              Clínicas
            </span>
          </h2>
          <p className="js-splittext-lines fsz-16 mt-30 mb-30 color-gray lh-2 ltspc-2">
            Design sofisticado e funcionalidade pensada para o bem-estar a
            ambientes modernos e acolhedores, criados para oferecer uma
            experiência única de atendimento e elevar o padrão de cuidado.
          </p>
          <p className="js-splittext-lines fsz-16 mt-30 mb-30 color-gray lh-2 ltspc-2">
            Cada detalhe é cuidadosamente planejado, resultando em espaços que
            inspiram confiança, promovem conforto e refletem o compromisso com a
            excelência em cada etapa do atendimento.
          </p>
        </div>

        <div className="col-lg-6 bg-white align-content-center p-50 ps-80">
          <h3 className="lh-1">
            <span className="js-splittext-lines fsz-35 color-gray font-palast-regular">
              Cada pausa merece um momento
            </span>
            <strong className="js-splittext-lines fsz-40 color-brown2 font-palast-bold-italic">
              {" "}
              inesquecível.
            </strong>
          </h3>

          <p className="js-splittext-lines fsz-16 mt-30 mb-20 color-gray lh-2 ltspc-2">
            Projetadas para profissionais que valorizam um ambiente moderno e
            acolhedor. Com espaços moduláveis e inteligentes, oferecem
            flexibilidade para diferentes especialidades, sempre com o máximo de
            conforto e privacidade.
          </p>
          <p className="js-splittext-lines fsz-16 mt-30 mb-20 color-gray lh-2 ltspc-2">
            A disposição estratégica dos consultórios e áreas de atendimento
            garante praticidade e fluidez no dia a dia, enquanto o design
            contemporâneo transmite confiança e elegância.
          </p>

          <button
            onClick={() => window.openModal()}
            className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-20 wow zoomIn slow"
          >
            <span className="ltspc-1"> Quero saber mais </span>
          </button>
        </div>
      </div>

      <section className="tc-slider-style" style={{ position: "relative" }}>
        <ImgSlider slides={clinics} />
      </section>

      <Plan
        id={'plan-health'}
        title={"Plantas"}
        subTitle={"Health"}
        slides={plansHealth}
        bgColor={"plan-bg-light-gay"}
      />
    </>
  );
}

export default Health;
